module.exports = __webpack_public_path__ + "img/bird.6f533aa7.png";